/**
 *
 * CheckoutOne
 *
 */

import React, { SyntheticEvent, memo, useState } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Space, Text } from '@cashfree-intl/coherent';
import { useLocation, useNavigate } from 'react-router';

import BrandingV2 from 'containers/BrandingV2/Loadable';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import BusinessCustomisation from 'containers/BusinessCustomisation/Loadable';
import NavigationBar from 'components/NavigationBar';
import { useSearchParams } from 'react-router-dom';
import makeSelectCheckoutOne from './selectors';
import reducer from './reducer';
import saga from './saga';
import CheckoutOneCanvasBanner from './components/CheckoutOneCanvasBanner';
import {
  BUSINESS_CUSTOMISATION,
  NAVIGATION_OPTIONS,
  VISUAL_CUSTOMISATION,
} from './constants';
import { getActiveNavigationName, getNavigationPath } from './helpers';

interface CheckoutOneProps {
  disableBanner?: boolean;
}
const CheckoutOne: React.FC<CheckoutOneProps> = ({ disableBanner = false }) => {

  useInjectReducer({ key: 'checkoutOne', reducer });
  useInjectSaga({ key: 'checkoutOne', saga, mode: '' });

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const env = searchParams.get('env') || '';

 
  const urlActiveNavigation = getActiveNavigationName(
    location.pathname.split('/').pop(),
  );

  const [localActiveNavigation, setLocalActiveNavigation] = useState<string>(
    urlActiveNavigation || VISUAL_CUSTOMISATION,
  );

  const activeNavigationName = disableBanner 
    ? localActiveNavigation 
    : urlActiveNavigation || VISUAL_CUSTOMISATION;

  const handleNavigationClick = (
    e: SyntheticEvent,
    { name }: { name: string; activeIndex: number },
  ) => {

    if (disableBanner) {
      e.preventDefault();
      setLocalActiveNavigation(name);
      return;
    }

    const { pathname } = location;
    const path: string = getNavigationPath(name);
    const oldPath: string = getNavigationPath(activeNavigationName);

    // Find the index of '/oldPath' in the pathname
    const pathIndex = pathname.indexOf(`/${oldPath}`);

    // Slice the pathname up to '/oldPath'
    let updatedPathName = pathname;
    if (pathIndex !== -1) {
      updatedPathName = pathname.slice(0, pathIndex);
    }

    navigate(`${updatedPathName}/${path}${env ? `?env=${env}` : ''}`);
  };

  const renderContent = () => {
    const subComponentMap = {
      [VISUAL_CUSTOMISATION]: <BrandingV2 />,
      [BUSINESS_CUSTOMISATION]: <BusinessCustomisation />,
    };

    return (
      subComponentMap[activeNavigationName] ||
      subComponentMap[VISUAL_CUSTOMISATION]
    );
  };

  return (
    <div>
      {!disableBanner && (
        <>
          <Helmet>
            <title>Checkout Customisation</title>
            <meta name="description" content="Checkout Customisation" />
          </Helmet>
          <CheckoutOneCanvasBanner />
          <br />
        </>
      )}
      <NavigationBar
        navigationOptions={NAVIGATION_OPTIONS.map(option => option.name)}
        activeNavigation={activeNavigationName}
        handleNavigationClick={handleNavigationClick}
      />
      {renderContent()}
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  checkoutOne: makeSelectCheckoutOne(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(CheckoutOne);
